import type { SentimentCues } from "@expert/shared-types";
import type { JSX } from "react";

import { Flex, Group, Text } from "@mantine/core";

import styles from "./Sentiment.module.css";

export function Sentiment(sentiment: SentimentCues): JSX.Element | undefined {
    const getSentimentColor = () => {
        switch (sentiment.name) {
            case "frustrated":
                return "red.7";
            case "satisfied":
                return "green";
            case "impressed":
                return "green.6";
            case "neutral":
                return "gray";
            default:
                return "gray";
        }
    };
    return (
        <Flex p="5px" color="gray.7" fz="xs" bg="gray.8" w="100%" h="50px" justify={"flex-start"} align={"center"}>
            <Group bg={getSentimentColor()} className={styles.sentimentGroup} />
            <Text span fz="xs" pr="3xs">
                Customer feels
            </Text>
            <Text span fz="xs" fw="bold">
                {sentiment.name}
            </Text>
        </Flex>
    );
}
